import { embeddingReducerPath } from './const';
import { EmbeddingStateSliceShape } from './types';

export const embeddingPushNotificationsSubscribedSelector = (state: EmbeddingStateSliceShape) =>
  state[embeddingReducerPath].sharedState.isPushNotificationsSubscribed;
